module.exports = __webpack_public_path__ + "img/calender.56391dd1.svg";